import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import { Panel, FormGroup, FormControl, ControlLabel, Button, Modal } from 'react-bootstrap'

import getServerURL from '../../../functions/getServerURL'

import { setUser } from '../reducers/manageLogin'

class ResetPassword extends Component {

  state = {
    checkingToken: true,
    tokenIsValid: false,
    newPassword: '',
    confirmNewPassword: '',
    errorMessage: '',
    savingNewPassword: false,
    currentUser: {},
  }


  componentDidMount() {
    this.checkToken()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.routerProps.match.params.token !== this.getToken() || prevProps.routerProps.match.params.token_id !== this.getTokenId()) {
      this.checkToken()
    }
  }

  getToken = () => {
    let token
    try {
      token = this.props.routerProps.match.params.token
    } catch (error) {
      token = null
    }

    return token
  }

  getTokenId = () => {
    let tokenId
    try {
      tokenId = this.props.routerProps.match.params.token_id
    } catch (error) {
      tokenId = null
    }

    return tokenId
  }


  checkToken = () => {
    const token = this.getToken()
    const token_id = this.getTokenId()

    axios({
      method: "POST",
      url: `${getServerURL()}recover-password-token-check/`,
      data: { token, token_id },
    })
    .then((response) => {
      this.setState({currentUser: response.data})
      return this.setState({
        checkingToken: false,
        tokenIsValid: true,
      })
    })
    .catch(error => {
      return this.setState({
        checkingToken: false,
        tokenIsValid: false,
      })
    })
  }


  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })


  handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      return this.saveNewPassword()
    }
  }


  getValidationState = () => {
    const { newPassword, confirmNewPassword } = this.state
    if (newPassword && confirmNewPassword && newPassword !== confirmNewPassword) {
      return 'error'
    } else if (newPassword && confirmNewPassword && newPassword.length < 8) {
      return 'error'
    } else if (newPassword && confirmNewPassword && newPassword === confirmNewPassword) {
      return 'success'
    }
  }

  saveNewPassword = () => {
    const { newPassword, confirmNewPassword } = this.state
    const token = this.getToken()
    const token_id = this.getTokenId()

    this.setState({ errorMessage: '' })

    if (newPassword !== confirmNewPassword) {
      return this.setState({ errorMessage: 'New passwords do not match' })
    }

    if (newPassword.length < 8) {
      return this.setState({ errorMessage: 'Your new password must be at least 8 characters in length' })
    }

    this.setState({ savingNewPassword: true })

    axios({
      method: "PATCH",
      url: `${getServerURL()}recover-password/`,
      data: {
        new_password: newPassword,
        token,
        token_id,
      }
    })
    .then(response => {
      this.setState({
        savingNewPassword: false,
        newPassword: '',
        confirmNewPassword: '',
      })

      localStorage.setItem('token', response.data.token)
      this.props.setUser(this.state.currentUser)

      swal({
        title: "Success",
        text: "Your password has been changed",
        icon: "success",
        button: "Continue",
      })
      .then(() => this.props.routerProps.history.replace('/'))
    })
    .catch(error => {
      this.setState({ savingNewPassword: false })
      if (error && error.response && error.response.data && error.response.data.non_field_errors) {
        return this.setState({ errorMessage: error.response.data.non_field_errors })
      } else if (error && error.response && error.response.data && error.response.data.message) {
        return this.setState({ errorMessage: error.response.data.message })
      } else {
        const errorMessage = 'An error occured while attempting to save your new password. Please try again.'
        return this.setState({ errorMessage })
      }
    })
  }


  render() {

    const { newPassword, confirmNewPassword, errorMessage, savingNewPassword, checkingToken,
    tokenIsValid } = this.state

    if (checkingToken === true) {
      return (
        <div id="ResetPassword" className='login-body'>
          <center>
            <h4 style={{textAlign: 'center'}}>
              Verifying user...
            </h4>
          </center>
        </div>
      )
    } else if (tokenIsValid === false) {
      return (
        <div id="ResetPassword" className='login-body'>
          <center>
            <h2>
              Unable to authorize password reset
            </h2>
            <h5>
              Your password reset link is either invalid or has expired. To request a new one, please go to the login page.
            </h5>

            <br/>

            <Button onClick={() => this.props.routerProps.history.replace('/')}>
              Back
            </Button>
          </center>
        </div>
      )
    } else {
      return (
        <div id="ResetPassword" className='login-body'>

          <Modal
            show={savingNewPassword}
            onHide={() => null}
          >
            <Modal.Body>
              <center>
                <img alt="loader" src={require("../../../static/images/spinner.gif")} />
                <h5 style={{textAlign: 'center'}}>
                  Saving new password...
                </h5>
              </center>
            </Modal.Body>
          </Modal>

          <Panel id="ResetPasswordPanel">
            <Panel.Heading>
              {this.state.currentUser.first_name ?
                `Reset Password - ${this.state.currentUser.first_name} ${this.state.currentUser.last_name}`
                :
                'Reset Password'

              }
            </Panel.Heading>
            <Panel.Body onKeyDown={this.handleEnterPress}>
              <p>
                Passwords must be at least 8 characters in length.
              </p>

              {errorMessage ?
                <h5 className='required'>
                  {errorMessage}
                </h5>
                :
                null
              }

              <FormGroup validationState={this.getValidationState()}>
                <ControlLabel>
                  New Password
                </ControlLabel>
                <FormControl
                  data-private
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={this.handleChange}
                >
                </FormControl>
                <FormControl.Feedback />
              </FormGroup>

              <FormGroup validationState={this.getValidationState()}>
                <ControlLabel>
                  Confirm New Password
                </ControlLabel>
                <FormControl
                  data-private
                  type="password"
                  name="confirmNewPassword"
                  value={confirmNewPassword}
                  onChange={this.handleChange}
                >
                </FormControl>
                <FormControl.Feedback />
              </FormGroup>

              <br/>

              <Button
                bsStyle="primary"
                onClick={this.saveNewPassword}
              >
                Save
              </Button>
            </Panel.Body>
          </Panel>
        </div>
      )
    }
  }
}


export default connect(null, { setUser })(ResetPassword)



// WEBPACK FOOTER //
// ./src/routes/login/components/ResetPassword.js